import { Button, createTheme, ThemeProvider } from "@mui/material";
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import './App.css';
import { Dashboard } from './Pages/Dashboard';
import { Login } from "./Pages/Login";
import { Workspace } from './Pages/Workspace';
// import { theme as baseTheme } from "./Theme";
import { USER_ACL } from "./types/types";
import { PrivateRoute } from "./Components/PrivateRoute";
import { Admin } from "./Pages/Admin";
import { useEffect, useMemo, useState } from "react";
import { getAppTheme, ThemeContext } from "./Theme";
import { Loading } from "./Pages/Loading";
import { Unauth } from "./Pages/Unauth";


export const THEME_KEY = "appTheme"; // localStorage key

export const getStoredTheme = (): "light" | "dark" => {
  const stored = localStorage.getItem(THEME_KEY);
  return stored === "dark" ? "dark" : "light";
};

function App() {
  const [mode, setMode] = useState<"light" | "dark">(getStoredTheme);

  useEffect(() => {
    localStorage.setItem(THEME_KEY, mode);
  }, [mode]);

  const baseTheme = useMemo(() => getAppTheme(mode), [mode]);

  return (
    <ThemeContext value={{ mode, setMode }}>
      <ThemeProvider theme={baseTheme}>
        <Router>
          <Routes>
            <Route
              path="/workspace"
              element={
                <Workspace />
              }
            />
            <Route
              path="/login"
              element={
                <Login />
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute allowedACLs={[USER_ACL.USER, USER_ACL.ADMIN]}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <Workspace />
              }
            />
            <Route
              path="/admin"
              element={
                <PrivateRoute allowedACLs={[USER_ACL.ADMIN]}>
                  <Admin />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </ThemeProvider>
    </ThemeContext>
  );
}

export default App;
